import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

import { ListCard } from './ListCard';
import { FadeIn } from 'common/components/core/animations';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import theme from './CollapsibleListCard.scss';

const collapsibleListCardFactory = () => {
    const CollapsibleListCard = ({ CardComponent, CollapseComponent }) => {
        class CollapsibleListCardComponent extends Component {
            constructor(props) {
                super(props);
                this.handleClick = this.handleClick.bind(this);
            }

            handleClick(event) {
                const { onClick } = this.props;
                onClick?.(event);
            }

            onChange = (...args) => {
                const { onChange } = this.props;
                onChange(...args);
            };

            getRightIcon = () => {
                const { rightIcon, isExpandable, isExpanded } = this.props;
                if (!rightIcon) {
                    return isExpandable
                        ? isExpanded
                            ? 'arrow-up'
                            : 'arrow-down'
                        : null;
                }
                return rightIcon;
            };

            renderCollapseComponent = () => {
                const { isExpanded, theme } = this.props;
                return isExpanded ? (
                    <div className={classnames(theme.collapseContainer)}>
                        <CollapseComponent {...this.props} />
                    </div>
                ) : null;
            };
            render() {
                const {
                    theme,
                    title,
                    subtitle,
                    leftText,
                    isSelected,
                    isExpanded,
                    isExpandable,
                    leftIconBgColor,
                    isLoading,
                    className,
                    disableTransition
                } = this.props;
                const { style, ...passProps } = this.props;
                // user appear

                return (
                    <div
                        style={style}
                        className={classnames(
                            className,
                            theme.collapseCardWrap,
                            theme[leftIconBgColor],
                            {
                                [theme.isExpanded]: isExpanded,
                                [theme.isSelected]: isSelected,
                                [theme.isLoading]: isLoading
                            }
                        )}
                        data-toolbox="collapse"
                    >
                        {CardComponent ? (
                            <CardComponent
                                {...passProps}
                                rightIcon={this.getRightIcon()}
                            />
                        ) : (
                            <ListCard
                                theme={theme}
                                onClick={this.handleClick}
                                title={title}
                                subtitle={subtitle}
                                leftText={leftText}
                                leftIconBgColor={leftIconBgColor}
                                rightIcon={
                                    isExpandable
                                        ? isExpanded
                                            ? 'arrow-up'
                                            : 'arrow-down'
                                        : null
                                }
                                isSelected={isSelected}
                                isLoading={isLoading}
                            />
                        )}
                        {disableTransition ? (
                            <div
                                className={classnames({
                                    [theme.collapseContainerWrap]:
                                        theme.collapseContainerWrap
                                })}
                            >
                                {this.renderCollapseComponent()}
                            </div>
                        ) : (
                            <CSSTransitionGroup
                                transitionAppear
                                className={classnames({
                                    [theme.collapseContainerWrap]:
                                        theme.collapseContainerWrap
                                })}
                                transitionAppearTimeout={0}
                                transitionName={FadeIn}
                                transitionEnterTimeout={0}
                                transitionLeaveTimeout={0}
                            >
                                {this.renderCollapseComponent()}
                            </CSSTransitionGroup>
                        )}
                    </div>
                );
            }
        }
        return compose(
            themr('CollapsibleListCard', theme),
            translate('translations')
        )(CollapsibleListCardComponent);
    };
    return CollapsibleListCard;
};

const themedFactory = collapsibleListCardFactory({ theme });
const ThemedCollapsibleListCard = themedFactory({});

export default collapsibleListCardFactory({ theme });
export {
    ThemedCollapsibleListCard as CollapsibleListCard,
    themedFactory as collapsibleListCardFactory
};
